/** Deep link para um agendamento no histórico */
export function getHistoricoAgendamentoPath(agendamentoId: number): string {
  return `/historico?agendamento=${agendamentoId}`
}
